import type { GetCategoriesLeafLight } from '@backmarket/http-api/src/api-specs-catalog/catalog-access'

export function transformPayloadToOptions(data: GetCategoriesLeafLight) {
  return data.results
    .filter((category) => !!category.categoryName)
    .sort((a, b) => {
      if (a.categoryName < b.categoryName) return -1
      if (a.categoryName > b.categoryName) return 1

      return 0
    })
    .map((category) => ({
      label: category.categoryName,
      value: String(category.marketplaceCategoryId),
    }))
}
